import moment from 'moment/moment'

import { ISO_FORMAT_DATE } from './constants'

export default function ISODateCalcDiff(firstDate, secondDate) {
  if (!firstDate && !secondDate) return null
  const calc = moment(secondDate, ISO_FORMAT_DATE).diff(moment(firstDate, ISO_FORMAT_DATE))
  const duration = moment.duration(calc)
  return moment.utc(duration.asMilliseconds()).format('HH:mm')
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/ISODateCalcDiff.js